import BaseApi from './BaseApi';
// import * as constantsConfig from '@/constants/config';


export default class IndexApi extends BaseApi {
  // 1.获取站点运营趋势
  async selectStationOperCurrent(info) {
    return await this.get(`screenStationInfo/selectStationOperCurrent`, info);
  }
  // 2.获取月增通道数图表
  async selectAddPassFromMonth(info) {
    return await this.get(`screenStationInfo/selectAddPassFromMonth`, info);
  }
  // 3.获取实时告警数据
  async selectActualTimeAlarm(info) {
    return await this.get(`screenFaultAlarm/selectActualTimeAlarm`, info);
  }
  // 4.获取日告警数量
  async selectDailyAlarm(info) {
    return await this.get(`screenFaultAlarm/selectDailyAlarm`, info);
  }
  // 5.获取城市预警排名数据
  async selectCityEarlyWarningRanking(info) {
    return await this.get(`screenFaultAlarm/selectCityEarlyWarningRanking`, info);
  }
  // 6.获取预警趋势
  async selectAlarmCurrent(info) {
    return await this.get(`screenFaultAlarm/selectAlarmCurrent`, info);
  }
  // 7.获取预警类型分布
  async selectAlarmTypeFrom(info) {
    return await this.get(`screenFaultAlarm/selectAlarmTypeFrom`, info);
  }
  // 8.获取最新站点告警列表
  async selectStationAlarmList(info) {
    return await this.get(`screenFaultAlarm/selectStationAlarmList`, info);
  }
  // 9.获取故障率信息
  async selectAlarmRateInfo(info) {
    return await this.get(`screenFaultAlarm/selectAlarmRateInfo`, info);
  }
  //获取乐橙云token
  async getKitToken(info) {
    return await this.post(`imou/getKitToken`, info);
  }
  //获取萤石云token
  async getAccessToken(info) {
    return await this.post(`ezviz/getAccessToken`, info);
  }
}
export const indexRight = new IndexApi();